import { createFileRoute } from '@tanstack/react-router';
import DripContactOptOutPage from '../views/drip/contacts/contact/opt-out';

export const Route = createFileRoute('/drip/contacts/$uuid/opt-out')({
  component: DripContactOptOutPage,
});
